// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compound-button_a8d4a1d9 {
  z-index: 0;
  position: relative;
}
.compound-button_a8d4a1d9 .compound-button__primary_a8d4a1d9 {
  border-radius: 0.167em 0 0 0.167em;
}
.compound-button_a8d4a1d9 .compound-button__primary_a8d4a1d9:focus-visible {
  z-index: 1;
}
.compound-button_a8d4a1d9 .compound-button__secondary_a8d4a1d9 {
  padding: 0 0 0 0.667rem;
  margin-left: -1px;
  border-radius: 0 0.167em 0.167em 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"compound-button": `compound-button_a8d4a1d9`,
	"compound-button__primary": `compound-button__primary_a8d4a1d9`,
	"compound-button__secondary": `compound-button__secondary_a8d4a1d9`
};
export default ___CSS_LOADER_EXPORT___;
